import { Box, Container, Drawer } from '@material-ui/core';
import React, { ReactElement } from 'react';

import DrawerToolbar from 'common/components/drawer/drawer-toolbar';
import Department from 'components/setting/models/department';

import QuickMessageForm from './quick-message-form';

function NewQuickMessageDrawer({
  departments,
  open,
  onClose,
  onCreate,
}: {
  departments: Department[];
  open: boolean;
  onClose(): void;
  onCreate(value: any, createMore: boolean): Promise<void>;
}): ReactElement {
  return (
    <Drawer PaperProps={{ style: { width: '40%' } }} variant="temporary" anchor="right" open={open} onClose={onClose}>
      <DrawerToolbar title="Add Quick Message" onClose={onClose} />
      <Box mb={1} />
      <Container>
        {open && <QuickMessageForm departments={departments} onCancel={onClose} onSubmit={onCreate} />}
      </Container>
    </Drawer>
  );
}

export default NewQuickMessageDrawer;
